import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Search, ChevronDown, ChevronRight, Plus, MoreVertical, Image as ImageIcon, Star, AlertTriangle, RefreshCw } from 'lucide-react';
const MENU_TABS = [{
  label: 'Products',
  path: ''
}, {
  label: 'Categories',
  path: 'categories'
}, {
  label: 'Modifiers',
  path: 'modifiers'
}, {
  label: 'Combos',
  path: 'combos'
}, {
  label: 'Stock',
  path: 'stock'
}, {
  label: 'Promotions',
  path: 'promotions'
}, {
  label: 'Performance',
  path: 'performance'
}];
const CATEGORIES = [{
  name: 'BURGERI',
  icon: '🍔',
  count: 42,
  expanded: true
}, {
  name: 'PALAČINKE',
  icon: '🥞',
  count: 35,
  expanded: false
}, {
  name: 'SALATE',
  icon: '🥗',
  count: 12,
  expanded: false
}, {
  name: 'GIROS',
  icon: '🌯',
  count: 8,
  expanded: false
}];
const PRODUCTS = [{
  id: 1,
  name: 'BIG Double Collina Smash + pomfrit + Pepsi',
  category: 'BURGERI',
  price: '890 RSD',
  cost: '312 RSD',
  margin: '65%',
  sales: 261,
  rating: 9.2,
  stock: 'in_stock',
  station: '🍔 Burgeri',
  locations: 'All locations',
  bestSeller: 1,
  expanded: true
}, {
  id: 2,
  name: 'Supreme Collina Triple Smash + Bacon',
  category: 'BURGERI',
  price: '1,190 RSD',
  cost: '445 RSD',
  margin: '63%',
  sales: 77,
  rating: 10,
  stock: 'in_stock',
  station: '🍔 Burgeri',
  locations: 'All locations',
  bestSeller: 2,
  new: true,
  expanded: true
}, {
  id: 3,
  name: '2X Collina burger + pomfrit + 2x Pepsi',
  category: 'BURGERI',
  price: '790 RSD',
  sales: 58,
  stock: 'in_stock',
  expanded: false
}, {
  id: 4,
  name: 'BIG Double Butter Smash',
  category: 'BURGERI',
  price: '690 RSD',
  sales: 13,
  stock: 'low_stock',
  expanded: false
}, {
  id: 5,
  name: 'Classic Burger',
  category: 'BURGERI',
  price: '450 RSD',
  sales: 34,
  stock: 'out_of_stock',
  expanded: false
}];
function StockBadge({
  status
}: {
  status: string;
}) {
  if (status === 'in_stock') return <span className="text-xs font-bold text-accent-success flex items-center gap-1" data-id="element-1450">
        ● In Stock
      </span>;
  if (status === 'low_stock') return <span className="text-xs font-bold text-accent-warning flex items-center gap-1" data-id="element-1451">
        ⚠️ Low Stock
      </span>;
  return <span className="text-xs font-bold text-accent-error flex items-center gap-1" data-id="element-1452">
      🔴 Out
    </span>;
}
export function Products() {
  const [showSyncModal, setShowSyncModal] = useState(false);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1453">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1454">
        <div data-id="element-1455">
          <h1 className="text-2xl font-bold text-text-primary flex items-center gap-3" data-id="element-1456">
            Menu Management{' '}
            <span className="text-lg font-normal text-text-secondary" data-id="element-1457">
              247 items · 8 categories
            </span>
          </h1>
        </div>
        <div className="flex items-center gap-3" data-id="element-1458">
          <Button onClick={() => setShowSyncModal(true)} className="bg-blue-600 hover:bg-blue-700 text-white border-none" data-id="element-1459">
            <RefreshCw size={16} className="mr-2" data-id="element-1460" /> Sync to Wolt
          </Button>
          <Button icon={<Plus size={16} data-id="element-1462" />} data-id="element-1461">Add Product</Button>
        </div>
      </div>

      <TabNavigation tabs={MENU_TABS} basePath="/menu" data-id="element-1463" />

      {/* Filters */}
      <div className="flex flex-wrap gap-3 items-center mb-6" data-id="element-1464">
        <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1465">
          All Categories <ChevronDown size={14} data-id="element-1466" />
        </button>
        <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1467">
          All Locations <ChevronDown size={14} data-id="element-1468" />
        </button>
        <button className="flex items-center gap-2 px-3 py-2 bg-background-elevated rounded-lg text-sm font-medium hover:bg-white/5 transition-colors" data-id="element-1469">
          Active <ChevronDown size={14} data-id="element-1470" />
        </button>
        <div className="relative ml-auto" data-id="element-1471">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-1472" />
          <input type="text" placeholder="Search products..." className="bg-background-elevated border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-accent-primary w-64" data-id="element-1473" />
        </div>
      </div>

      {/* Product List */}
      <div className="space-y-4" data-id="element-1474">
        {CATEGORIES.map(cat => <div key={cat.name} className="space-y-2" data-id="element-1475">
            <button className="w-full flex items-center justify-between p-3 bg-background-elevated/50 rounded-lg hover:bg-white/5 transition-colors" data-id="element-1476">
              <div className="flex items-center gap-3 font-bold" data-id="element-1477">
                {cat.expanded ? <ChevronDown size={18} data-id="element-1478" /> : <ChevronRight size={18} data-id="element-1479" />}
                <span data-id="element-1480">
                  {cat.icon} {cat.name}
                </span>
                <span className="text-text-secondary font-normal text-sm" data-id="element-1481">
                  ({cat.count} items)
                </span>
              </div>
            </button>

            {cat.expanded && <div className="space-y-3 pl-4" data-id="element-1482">
                {PRODUCTS.filter(p => p.category === cat.name).map(product => <Card key={product.id} className="group hover:border-white/20 transition-colors" noPadding data-id="element-1483">
                      {product.expanded ? <div className="p-4 flex gap-4" data-id="element-1484">
                          <div className="w-24 h-24 bg-white/5 rounded-lg flex items-center justify-center shrink-0" data-id="element-1485">
                            <ImageIcon className="text-text-secondary" size={32} data-id="element-1486" />
                          </div>
                          <div className="flex-1 min-w-0" data-id="element-1487">
                            <div className="flex justify-between items-start mb-2" data-id="element-1488">
                              <div data-id="element-1489">
                                <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-1490">
                                  {product.name}
                                  {product.new && <span className="bg-accent-error text-white text-[10px] px-1.5 py-0.5 rounded font-bold" data-id="element-1491">
                                      🔥 NOVO
                                    </span>}
                                </h3>
                                <div className="text-sm text-text-secondary flex items-center gap-3 mt-1" data-id="element-1492">
                                  {product.bestSeller && <span className="text-accent-primary font-bold" data-id="element-1493">
                                      #{product.bestSeller} Best Seller
                                    </span>}
                                  <span data-id="element-1494">{product.sales} sold this week</span>
                                  {product.rating && <span className="flex items-center gap-1 text-accent-success" data-id="element-1495">
                                      <Star size={12} fill="currentColor" data-id="element-1496" />{' '}
                                      {product.rating}
                                    </span>}
                                </div>
                              </div>
                              <div className="flex gap-2" data-id="element-1497">
                                <Button size="sm" variant="secondary" data-id="element-1498">
                                  Edit
                                </Button>
                                <button className="p-2 hover:bg-white/10 rounded-lg text-text-secondary" data-id="element-1499">
                                  <MoreVertical size={16} data-id="element-1500" />
                                </button>
                              </div>
                            </div>

                            <div className="grid grid-cols-3 gap-8 mb-4" data-id="element-1501">
                              <div data-id="element-1502">
                                <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-1503">
                                  Price
                                </div>
                                <div className="font-mono font-bold" data-id="element-1504">
                                  {product.price}
                                </div>
                              </div>
                              <div data-id="element-1505">
                                <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-1506">
                                  Cost
                                </div>
                                <div className="font-mono text-text-secondary" data-id="element-1507">
                                  {product.cost}
                                </div>
                              </div>
                              <div data-id="element-1508">
                                <div className="text-xs text-text-secondary uppercase mb-1" data-id="element-1509">
                                  Margin
                                </div>
                                <div className="font-mono text-accent-success" data-id="element-1510">
                                  {product.margin}
                                </div>
                              </div>
                            </div>

                            <div className="flex items-center gap-6 text-sm" data-id="element-1511">
                              <div className="flex items-center gap-2 text-text-secondary" data-id="element-1512">
                                <span data-id="element-1513">📍</span> {product.locations}
                              </div>
                              <div className="flex items-center gap-2 text-text-secondary" data-id="element-1514">
                                <span data-id="element-1515">{product.station}</span>
                              </div>
                              <StockBadge status={product.stock} data-id="element-1516" />
                            </div>
                          </div>
                        </div> : <div className="p-3 flex items-center justify-between cursor-pointer hover:bg-white/5" data-id="element-1517">
                          <div className="flex items-center gap-3" data-id="element-1518">
                            <ChevronRight size={16} className="text-text-secondary" data-id="element-1519" />
                            <span className="font-medium" data-id="element-1520">{product.name}</span>
                          </div>
                          <div className="flex items-center gap-6 text-sm" data-id="element-1521">
                            <span className="font-mono" data-id="element-1522">{product.price}</span>
                            <span className="text-text-secondary w-20 text-right" data-id="element-1523">
                              {product.sales} sold
                            </span>
                            <div className="w-24 flex justify-end" data-id="element-1524">
                              <StockBadge status={product.stock} data-id="element-1525" />
                            </div>
                          </div>
                        </div>}
                    </Card>)}
              </div>}
          </div>)}
      </div>

      {/* Sync Modal */}
      {showSyncModal && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-1526">
          <Card className="w-full max-w-md" data-id="element-1527">
            <h3 className="text-xl font-bold mb-4" data-id="element-1528">Sync to Wolt</h3>
            <div className="space-y-4 mb-6" data-id="element-1529">
              <p className="text-text-secondary" data-id="element-1530">Changes to push:</p>
              <ul className="space-y-2 text-sm" data-id="element-1531">
                <li className="flex items-center gap-2" data-id="element-1532">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-primary" data-id="element-1533"></span>
                  3 price updates
                </li>
                <li className="flex items-center gap-2" data-id="element-1534">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-primary" data-id="element-1535"></span>
                  2 new products
                </li>
                <li className="flex items-center gap-2" data-id="element-1536">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-primary" data-id="element-1537"></span>
                  5 stock status changes
                </li>
                <li className="flex items-center gap-2" data-id="element-1538">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-primary" data-id="element-1539"></span>
                  1 product deactivated
                </li>
              </ul>
              <p className="text-xs text-text-muted pt-2 border-t border-white/5" data-id="element-1540">
                Last sync: Today 14:32
              </p>
            </div>
            <div className="flex justify-end gap-3" data-id="element-1541">
              <Button variant="secondary" onClick={() => setShowSyncModal(false)} data-id="element-1542">
                Cancel
              </Button>
              <Button onClick={() => setShowSyncModal(false)} data-id="element-1543">Sync Now</Button>
            </div>
          </Card>
        </div>}
    </div>;
}